import React from "react";
import {
  withStyles,
  InputLabel,
  Input,
  FormControl,
  FormHelperText,
} from "@material-ui/core";

const styles = (theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  cssLabel: {
    color: "#000!important",
    fontWeight: "bold",
    fontSize: "23px",
    "&$cssFocused:not($error)": {
      color: "#000!important",
      fontWeight: "bold",
      fontSize: "23px",
    },
  },
  cssFocused: {},
  cssUnderline: {
    "&:after": {
      borderBottomColor: "#b3b3b3",
    },
    "&:before": {
      borderBottomColor: "#b3b3b3",
    },
    "&:hover": {
      borderBottomColor: "#b3b3b3",
    },
    "&:hover:not($disabled):not($error):not($focused):before": {
      borderBottomColor: "#b3b3b3",
    },
  },
  disabled: {},
  error: {
    color: "#EE2737!important",
    borderBottomColor: "#EE2737!important",
    width: "240px!important"
  },
  focused: {},
});

class TextRipleyComponent extends React.Component {

  constructor(props) {
    super(props);
    this.textInput = React.createRef();
  }

  focus = () => {
    this.textInput.current.focus();
  }

  render() {
    const { classes } = this.props;
    let txtId = this.props.id;
    let label;
    if (!txtId) {
      txtId = "txtInputText";
    }
    if (this.props.showLabel) {
      label = <InputLabel id="labelInputText" shrink formlabelclasses={{ root: classes.cssLabel, }} htmlFor={txtId}>{this.props.label}</InputLabel>
    }

    return (
      <FormControl id="inputText" fullWidth={this.props.fullWidth} >
        {label}
        < Input
          classes={{
            underline: classes.cssUnderline,
          }}
          id={txtId}
          value={this.props.value}
          onChange={this.props.onChange}
          error={this.props.error}
          onFocus={this.props.onFocus}
          onBlur={this.props.onBlur}
          autoComplete="off"
          placeholder={this.props.placeholder}
          type={this.props.type}
          disabled={this.props.disabled}
          onPaste={this.props.onPaste}
          autoFocus={this.props.autoFocus}
          inputRef={this.textInput}
          onKeyDown={this.props.onKeyDown}
        />
        <FormHelperText id="component-error-text" error={this.props.error}>
          {this.props.errorText}
        </FormHelperText>
      </FormControl >
    );
  }
}

TextRipleyComponent.defaultProps = {
  showLabel: true
}
export default withStyles(styles)(TextRipleyComponent);
